/* Source: /tmp/jacbuilder-deploy-scratch/deploy-8asygg26/components/shared/InfoTip.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { HugeiconsIcon } from "@hugeicons/react";
import { InformationCircleIcon } from "@hugeicons/core-free-icons";
import { cn } from "../../lib/utils.js";
function InfoTip(props) {
  const {label, lines, floating: floating = true, contentLabel: contentLabel = ""} = props;
  return __jacJsx("details", {"className": cn("group text-left", (floating ? "relative inline-block align-middle" : "block"))}, [__jacJsx("summary", {"aria-label": label, "title": label, "className": "inline-flex size-7 cursor-pointer list-none items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring group-open:text-primary [&::-webkit-details-marker]:hidden"}, [__jacJsx(HugeiconsIcon, {"icon": InformationCircleIcon, "strokeWidth": 2, "className": "size-4"}, [])]), __jacJsx("div", {"aria-label": (contentLabel || label), "className": cn("flex flex-col gap-2 text-xs leading-relaxed", (floating ? "absolute left-0 top-full z-30 mt-1 w-80 max-w-[calc(100vw-2rem)] rounded-md border border-border bg-popover p-3 text-popover-foreground shadow-lg" : "mt-1 text-muted-foreground"))}, [(() => {
    let __jac_view_kids = [false];
    __jac_view_kids[0] = (() => {
      let __jac_view_kids_1 = [];
      for (const line of lines) {
        __jac_view_kids_1.push(__jacJsx("p", {"key": line, "className": "break-words"}, [line]));
      }
      return __jac_view_kids_1;
    })();
    return __jacJsx(null, {}, __jac_view_kids);
  })()])]);
}
/*jac:refresh-boundary*/;
export {InfoTip};
//# sourceMappingURL=InfoTip.js.map
